// Choices offered by the quote request form. The API route accepts only these values.

export const CUSTOM_MODEL = 'custom'
export const UNSURE_MODEL = 'unsure'

export const USE_CASES: string[] = [
    "Full-time home",
    "Weekend or holiday home",
    "Holiday rental",
    "Home office or studio",
    "Something else"
]

export const TIMELINES: string[] = [
    "As soon as possible",
    "Within 6 months",
    "In 6 to 12 months",
    "Just exploring for now"
]

export const LAND_STATUSES: string[] = [
    "Yes, I have land",
    "I am looking for land",
    "Not yet"
]

export const VISIT_MESSAGE = "I would like to visit the workshop. Please suggest a few dates."
